import React from "react";
import { FilterBar, Menu, Select } from "@sscs/ui";
const Filter = ({ filter, categories, onFilterChange, }) => {
    return (React.createElement(FilterBar, { filters: [
            {
                id: "policy-categories",
                width: "220px",
                control: (React.createElement(Select, { id: "filter-policy-categories", labelId: "category-filter-label", label: "Filter by category", value: filter.id, displayEmpty: true, shrinkLabel: true, onChange: (value) => onFilterChange({
                        id: value,
                        severity: filter.severity,
                        effort: filter.effort,
                    }) },
                    React.createElement(Menu.Item, { id: "show-all-policy-categories", value: "ALL" }, "Show all categories"),
                    Object.keys(categories).map((key, index) => (React.createElement(Menu.Item, { id: `policy-category-${index}`, key: key, value: key }, categories[key]))))),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map